import { TemplateData } from "./templates-action";

export function generateTemplateDetailsPath(template: TemplateData): string {
  let path = `templates/details/${template.id}`;
  if (template.name) {
    path += `-${template.name.replace(/[^a-zA-Z0-9]/g, "-").toLowerCase()}`;
  }

  return path;
}
